// Note: This is only for routes the FE needs to interact with via AJAX
//       All other routes are automatically generated by Rails and
//       manually included via the generate_js_routes rake task
export default {
  startupPath() {
    return `/api/startups/me/show_free`;
  },
  updateStartupPath() {
    return `/api/startups/me/update_free`;
  },
  upgradePricingTierPath() {
    return `/api/startups/me/upgrade_pricing_tier`;
  },
  platformStatisticsPath() {
    return `/api/general/statistics`;
  },
  productCategoriesPath() {
    return `/api/shared/product_categories`;
  },
};
